import * as React from "react";
const SvgDoubleFlange = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 5, height: 20, viewBox: "0 0 5.0 20.0", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M 0.5 0.0 L 0.5 20.0 M 4.5 0.0 L 4.5 20.0", fill: "none", stroke: "currentColor", strokeWidth: 1 }));
export default SvgDoubleFlange;
